module.exports = __webpack_public_path__ + "img/choose-icon04.53e0d974.png";